module.exports = require("./ewo.js");